import { NgModule, inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    RouterModule,
    RouterStateSnapshot,
    Routes,
} from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { ErrorGlobalPageComponent } from './page/error-global-page/error-global-page.component';
import { LoadingPageComponent } from './page/loading-page/loading-page.component';
import { LoginComponent } from './page/login/login.component';
import { OnlyLoggedInGuard } from '@spdg/core';

export const appRoutes: Routes = [
    { path: '', component: LoadingPageComponent, pathMatch: 'full' },
    { path: 'start', component: LoadingPageComponent, pathMatch: 'full' },
    { path: 'logging-out', component: LoadingPageComponent, pathMatch: 'full' },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'entry',
        component: LoginComponent,
        data: { direct: true },
        pathMatch: 'full',
    },
    {
        path: 'app',
        canActivate: [
            (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
                inject(OnlyLoggedInGuard).canActivate(route, state),
        ],
        children: [
            {
                path: 'ecb-workbench/:id',
                data: { skipLandingPage: true },
                loadChildren: () =>
                    import('./modules/ecb-workbench/ecb-workbench.module').then(
                        (m) => m.WorkbenchScreenModule
                    ),
            },
            // {
            //     path: 'project',
            //     loadChildren: () =>
            //         import('./modules/designer/designer.module').then(
            //             (m) => m.DesignerModule
            //         ),
            // },
            {
                path: 'screening-of-activities/:id',
                data: { skipLandingPage: true },
                loadChildren: () =>
                    import(
                        './modules/screening-of-activities/screening-of-activities.module'
                    ).then((m) => m.ScreeningOfActivitiesModule),
            },
        ],
        component: MainLayoutComponent,
        data: { role: 'Admin' },
    },
    {
        path: 'configuration-failed',
        component: ErrorGlobalPageComponent,
        data: {
            errorSubtitle:
                'Oops, looks like the global configuration was not set correctly. Please fix the global suite configuration and rebuild the application',
            errorTitle: '!',
        },
    },
    {
        path: 'not-found',
        component: ErrorGlobalPageComponent,
        data: { errorSubtitle: 'Page not found', errorTitle: '404' },
    },
    {
        path: '**',
        component: ErrorGlobalPageComponent,
        data: { errorSubtitle: 'Page not found', errorTitle: '404' },
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {
            anchorScrolling: 'enabled',
            useHash: false,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
